import * as React from 'react';

export const LazyGestionDurabilityResults = React.lazy(() => import('./component'));
